import React, { Component } from 'react';
import CommentContaier from '../comments/CommentContainer'
import AttachmentsContainer from '../attachments/AttachmentsContainer';
import CasoSidebarInfo from '../casos/CasoSidebarInfo';

class SideContainer extends Component{
    render(){
        return(
            <div className="col-12">
                {this.props.activeSection === 'casodata' ? <CasoSidebarInfo options={this.props.options}/> : null}
                {this.props.activeSection === 'comments' ? <CommentContaier/> : null}
                {this.props.activeSection === 'attachments' ? <AttachmentsContainer/> : null}
            </div>
        )
    }
}
export default SideContainer


// WEBPACK FOOTER //
// ./resources/assets/js/components/viewer/SideContainer.jsx